module.exports = __webpack_public_path__ + "static/media/comp.eaee3317.jpg";